import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeGeneratePrescriptionMutation as useDeGeneratePrescriptionMutationType } from "@/modules/patients/detail/prescription/de/services/__generated__/useDeGeneratePrescriptionMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const mutation = graphql`
  mutation useDeGeneratePrescriptionMutation($input: De_generatePrescriptionDocumentInput!) {
    de_generatePrescriptionDocument(input: $input) {
      de_Prescription {
        id
        ...dePrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeGeneratePrescriptionMutationType>, "variables"> & {
  id: string
}

const useDeGeneratePrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeGeneratePrescriptionMutationType>(mutation, params)

  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: { id: config.id, patientId: patientById },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useDeGeneratePrescriptionMutation }
